import { useMemo } from 'react'
import { ColDef, ColGroupDef } from 'ag-grid-community'
import { useRowNumber } from '../../../../page-properties/bulksheet-properties/rowNumber'
import { dragAndDrop } from '../../../../page-properties/bulksheet-properties/dragAndDrop'
import { ProgramManagementSequenceNoCellRenderer } from '../../components/ProgramManagementSequenceNoCellRenderer'
import { basicColumns } from './basicColumns'
import { aggregationColumns } from './aggregationColumns'
import { ganttColumnGroup } from './ganttColumn'
import { PROGRAM_MANAGEMENT_ROW_TYPE } from '../../programManagement'

export { basicColumns, aggregationColumns }

const programDragAndDrop: ColDef = {
  ...dragAndDrop,
  rowDrag: params => {
    const type = params.data?.type
    return (
      type === PROGRAM_MANAGEMENT_ROW_TYPE.GROUP ||
      type === PROGRAM_MANAGEMENT_ROW_TYPE.PROJECT
    )
  },
  cellClassRules: {
    'hover-over-can-drop': params => {
      return (
        !params.context?.onTree &&
        params.context?.draggableNodeId &&
        params.node?.id === params.context?.draggableNodeId
      )
    },
  },
}

export const useColumnDefs = (): (ColDef | ColGroupDef)[] => {
  const rowNumberCol = useRowNumber()

  const columnDefs = useMemo(
    () => [
      {
        field: 'uuid',
        hide: true,
        suppressColumnsToolPanel: true,
      },
      {
        colId: 'blank',
        hide: true,
        width: 35,
        suppressColumnsToolPanel: true,
      },
      {
        ...rowNumberCol,
        // プロジェクト/ワークグループ/工程行はリンクにして、
        // その行をルートとするプロジェクト計画画面を別タブで開く
        cellRenderer: ProgramManagementSequenceNoCellRenderer,
      },
      programDragAndDrop,
      ...basicColumns,
      ...aggregationColumns,
      ganttColumnGroup,
    ],
    [rowNumberCol]
  )
  return columnDefs
}
